import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/theme';
import Navbar from './Navbar';
import TrialNotification from './TrialNotification';
import OrganizationAudit from './OrganizationAudit';

export default function AuditLogs() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const colors = getThemeColors(isDark);

  return (
    <div style={{ minHeight: '100vh', background: colors.background, transition: 'background-color 0.3s ease' }}>
      <Navbar />
      <TrialNotification />
      <div style={{ padding: '2rem', maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '2rem' }}>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              background: colors.buttonSecondaryBg,
              border: `1px solid ${colors.border}`,
              borderRadius: '8px',
              padding: '8px 16px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              color: colors.buttonSecondaryText,
              marginBottom: '1rem',
              transition: 'background-color 0.2s, border-color 0.2s, color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = colors.buttonSecondaryHoverBg}
            onMouseLeave={(e) => e.target.style.backgroundColor = colors.buttonSecondaryBg}
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"/>
            </svg>
            {t('profile.backToDashboard')}
          </button>
        </div>
        <OrganizationAudit />
      </div>
    </div>
  );
}

